import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'

// Read skill from localStorage
// ! Remember to change this setting
const userData = JSON.parse(localStorage.getItem('userData'))
const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
